// 🚨 AUTO-GENERADO desde ProductFormDataType.ts - No editar manualmente

export const ProductFormDataKeys = [
  "id",
  "codigo",
  "codigo_cabys",
  "existencias",
  "costo",
  "comision",
  "descripcion",
  "descripcion_fact",
  "minimo",
  "maximo",
  "codigobarras",
  "temporal",
  "activo",
  "precio1",
  "precio2",
  "precio3",
  "precio4",
  "imagen",
  "imagenAsset",
  "productfamily_id",
  "visibilidad",
  "exento",
  "existencias_compartidas",
  "tipo_producto",
  "tipo_impuesto",
  "porcentaje_impuesto",
  "unidad_medida",
  "categoryId",
  "category",
  "invoiceProducts",
  "invoiceTemplateProducts",
  "quoteProducts",
  "settlementProducts",
  "creditnoteProducts",
  "debitnoteProduct"
] as const;
